import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const sitemapNotFound = (provider: string) => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:${provider}:notfound`, 
        category: settings.categoryName 
    });
};

export default sitemapNotFound;